let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8PsNg"), load("ffEVr"), load("3vYMs")]).then(() => parcelRequire('ekFKF'));